import { urlLogin, urlSignup } from '@/urls';
import { Google } from './google';
import { Link } from 'react-router';

type AuthFormProps = {
  mode?: 'login' | 'signup';
};

export function AuthForm({ mode = 'login' }: AuthFormProps) {
  return (
    <div className="flex w-full max-w-lg items-center justify-center">
      <div className="flex flex-col gap-8">
        <div className="text-center">
          <h2 className="text-lg font-bold text-gray-900">
            {mode === 'login' ? 'Iniciá sesión en Playpadel' : 'Registrate en Playpadel'}
          </h2>
        </div>
        <div className="flex items-center justify-center">
          <Google />
        </div>
        <div className="text-center">
          {mode === 'login' && (
            <p className="text-sm text-gray-500">
              ¿No tenés una cuenta?{' '}
              <Link to={urlSignup()} className="text-blue-500">
                Registrate
              </Link>
            </p>
          )}
          {mode === 'signup' && (
            <p className="text-sm text-gray-500">
              ¿Ya tenés una cuenta?{' '}
              <Link to={urlLogin()} className="text-blue-500">
                Iniciá sesión
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
